import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import { iJournalEntry } from "./journal-entry-model";

export type ReverseJournalEntryParams = {
  occurredAt?: number;
  description?: string;
  metadata?: Record<string, unknown>;
};

export class JournalEntriesServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.journalEntries.configure(config);
  }

  journalEntries = new EntityServices<iJournalEntry>(
    SDKConfig,
    "journal-entries",
    {}
  );

  async reverseJournalEntry(
    id: string,
    params: ReverseJournalEntryParams = {}
  ): Promise<iJournalEntry> {
    const results: AxiosResponse<iJournalEntry> = await axios.post(
      this.config.basePath + `/journal-entries/${id}/reverse`,
      params,
      {
        headers: {
          Authorization: this.config.token,
        },
      }
    );
    return results.data;
  }
}
